export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9882.6b9af650.jpg";